import SubcontractRequestDelivery from '@/models/SubcontractRequestDelivery/SubcontractRequestDelivery';

export default class SubcontractRequestDeliveryFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.requestDeliveryNumber = '';
		this.id = '';
		this.purchaseOrderId  = '';
		this.purchaseOrderPurchaseOrderNumber = '';
		this.vendorId  = '';
		this.vendorCode = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.deliveryDateFrom = '';
		this.deliveryDateTo = '';
		this.remarksMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			requestDeliveryNumber : '0',
			id : '0',
			purchaseOrderId : '0',
			purchaseOrderPurchaseOrderNumber : '0',
			vendorId : '0',
			vendorCode : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			deliveryDateFrom : '0',
			deliveryDateTo : '0',
			remarksMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}